import JobCard from '@/components/visits/JobCard';
import { useTradeFieldPresentation } from '@/lib/tradeFieldPresentation';
import { TradesFieldJob, TradesFieldJobs } from './TradesField';
import { useParams, useSearchParams } from "react-router-dom";
import { useNavigationPresentation } from "@/lib/tradeNavigation";
import Jobs from "./JobsLive";
import JobDetail from "./JobDetail";
import JobCreate from "./JobCreate";
import TradesJobs from "./TradesJobs";
import { OFFICE } from "@/components/trades/jobShared";
import TradesJobDetail from "./TradesJobDetail";
import { Button } from "@/components/ui/button";

const SIMPLE_TABS = ["overview", "work", "time-materials", "documents", "commercial", "activity"];
function OperatingJobSurface({ kind }) {
  const field = useTradeFieldPresentation();
  const presentation = useNavigationPresentation();
  const { id, tab } = useParams();
  const [params] = useSearchParams();
  if (presentation.pending || field.pending) return <div role="status" className="p-6">Loading your workspace… <Button variant="outline" onClick={presentation.refresh}>Retry</Button></div>;
  const { user, trades } = presentation;
  if (kind === "detail" && (field.trades || trades && OFFICE.includes(user.role)) && params.get("visit") && (!tab || params.get("card") === "1")) return <JobCard key={JSON.stringify([user.org_id,user.id,id,params.get("visit")])} visitId={params.get("visit")} jobId={id} />;
  if (field.trades) return kind === "list" ? <TradesFieldJobs key={field.identity} /> : kind === "detail" ? <TradesFieldJob key={JSON.stringify([field.identity,id,tab])} /> : <p className="p-6">Job creation requires office or admin access.</p>;
  if (!trades) return kind === "list" ? <Jobs /> : kind === "create" ? <JobCreate /> : <JobDetail />;
  if (kind === "create" && !OFFICE.includes(user.role)) return <p className="p-6">Job creation requires office or admin access.</p>;
  // Retain all canonical advanced tabs and an explicit advanced presentation.
  if (kind === "detail" && (params.get("view") === "advanced" || (tab && !SIMPLE_TABS.includes(tab)))) return <JobDetail key={JSON.stringify([user.org_id, user.id, id])} />;
  const key = JSON.stringify([user.org_id, user.id, user.role, id]);
  return kind === "list" ? <TradesJobs key={key} /> : kind === "create" ? <JobCreate key={key} trades /> : <TradesJobDetail key={key} />;
}
export function OperatingJobs() { return <OperatingJobSurface kind="list" />; }
export function OperatingJobDetail() { return <OperatingJobSurface kind="detail" />; }
export function OperatingJobCreate() { return <OperatingJobSurface kind="create" />; }
